import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10.4616 1.21493V3.54826H2.77909L4.86742 1.45409L4.04492 0.631592L0.544922 4.13159L4.04492 7.63159L4.86742 6.80909L2.77909 4.71492H11.6283V1.21493H10.4616Z" fill="black"/>
</svg>
;
